import { useState, useRef } from 'react';
import { withStyles } from '@material-ui/core';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import GridConfig from '../../../../Settings/HolidayManagement/HolidayGrid/GridConfig';
import HolidayDataGrid from '../../../../Settings/HolidayManagement/HolidayGrid/HolidayDataGrid';
import AddHoliday from './AddHoliday';
import DeleteHoliday from './DeleteHoliday';
import styles from '../../../../Settings/styles';
import localStyles from './styles';
import AddCustomerSpecificHoliday from './AddCustomerSpecificHoliday';
import Events from '../../../../../../utilities/EventEmitter';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import { checkIfDateIsWithinDateRange } from '../../../../../common/utils/dateTimeUtils';

const HolidayGrid = ({
  classes,
  enqueueSnackbar,
  openModule,
  holidayOptions,
  refreshCustomerData,
  customerDetails,
  userData
}) => {
  const [showHolidayForm, setShowHolidayForm] = useState(false);
  const [selectedHolidayData, setSelectedHolidayData] = useState(null);
  const [selectedHoliday, setSelectedHoliday] = useState([]);
  const [showCustomerSpecificHolidayForm, setShowCustomerSpecificHolidayForm] = useState(null);

  const gridConfigRef = useRef(new GridConfig({ isEditCustomerDialog: true }));

  const openAddEditHolidayPanel = (isCustomerSpecificHoliday = false) => {
    setShowHolidayForm(!isCustomerSpecificHoliday);
    setShowCustomerSpecificHolidayForm(isCustomerSpecificHoliday);
  };

  const closeAddEditHolidayPanel = (selectedHoliday = []) => {
    setSelectedHoliday(selectedHoliday);
    setShowHolidayForm(false);
    setShowCustomerSpecificHolidayForm(false);
  };

  const runCommand = (command, props) => {
    if (command === 'deleteHoliday') {
      setSelectedHolidayData(props);
    }
    setSelectedHoliday([props.holidayId]);
  };

  const onCancelHolidayDeletion = () => {
    setSelectedHolidayData(null);
  };

  const refreshData = (startDate = null, endDate = null) => {
    const planDate = userData.userProfile.planDate;
    const isPlanDateWithinHoliday = checkIfDateIsWithinDateRange(planDate, startDate, endDate);
    if (isPlanDateWithinHoliday) {
      Events.emit('RefreshIBStore');
    }

    refreshCustomerData(true);
  };

  return (
    <>
      <HolidayDataGrid
        gridData={customerDetails.holidays}
        selectedRowData={selectedHoliday}
        gridConfig={gridConfigRef?.current}
        openAddEditHolidayPanel={openAddEditHolidayPanel}
        showHolidayForm={showHolidayForm}
        runCommand={runCommand}
        classes={classes}
        isEditCustomerDialog
      />
      {showHolidayForm && (
        <AddHoliday
          holidayOptions={holidayOptions}
          open={showHolidayForm}
          onClose={closeAddEditHolidayPanel}
          customerDetails={customerDetails}
          enqueueSnackbar={enqueueSnackbar}
          openModule={openModule}
          refreshData={refreshData}
        />
      )}
      {showCustomerSpecificHolidayForm && (
        <AddCustomerSpecificHoliday
          open={showCustomerSpecificHolidayForm}
          onClose={closeAddEditHolidayPanel}
          customerDetails={customerDetails}
          enqueueSnackbar={enqueueSnackbar}
          refreshData={refreshData}
        />
      )}
      {selectedHolidayData && (
        <DeleteHoliday
          onCancel={onCancelHolidayDeletion}
          selectedHolidayData={selectedHolidayData}
          enqueueSnackbar={enqueueSnackbar}
          customerDetails={customerDetails}
          refreshData={refreshData}
        />
      )}
    </>
  );
};

export default compose(
  withStyles((theme) => ({
    ...styles(theme),
    ...localStyles(theme)
  })),
  withSnackbar,
  withUserProfile
)(HolidayGrid);
